import { GetBodyInsuranceType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyInsurance/getBodyInsurance.type';
import { getBodyInsuranceFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyInsurance/getBodyInsuranceFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodyInsuranceOptions = ({ id }: GetBodyInsuranceType) => {
  return queryOptions({
    queryKey: ['get-body-insurance-get', id],
    queryFn: () => getBodyInsuranceFunction({ id }),
  });
};
